<template>
  <div>
    <el-button class="uploading-btn btn primary" type="primary" popper-class="popper-uploading"
      @click="dialogVisible = true">导入</el-button>
    <el-dialog :visible.sync="dialogVisible" title="导入" width="30%">
      <el-upload :file-list="fileList" class="upload-demo" :action="actionUrl + importUrl" :headers="uploadHeaders"
        multiple drag :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
        :on-exceed="handleExceed" :on-success="onSuccess">
        <div>
          <img src="@/assets/file-download-line.svg" alt="">
          <div class="el-upload__text" style="color: #000;">将文件拖到此处，或<em
              style="color: #1890FF;cursor: pointer;">点击上传</em></div>
        </div>
        <div class="el-upload__tip" slot="tip">下载模板：<span style="color: #1890FF;cursor: pointer;"
            @click="handleCommand('download')">点击下载</span></div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="failDialogVisible" title="导入提示" width="500">
      <div class="error-table">
        <div style="display: flex; justify-content: space-between;">
          <span style="color: #d9001b">以下数据导入失败，请检查</span>
          <el-button type="primary" text @click="handleDownload">下载全部数据</el-button>
        </div>
        <el-table :data="errTableData" border style="margin-top: 10px;">
          <el-table-column type="index" width="50" />
          <el-table-column prop="medicationName" label="药品名称" width="180" />
          <el-table-column prop="specifications" label="药品规格" width="180" />
          <el-table-column prop="result" label="导入结果" width="180" />
          <el-table-column prop="resultMsg" label="失败原因" />
        </el-table>
        <div style="margin-top: 10px; display: flex">
          共有{{ errTableDataNum }}条数据导入失败
          <div v-if="hint" style="margin-left: 10px; color: #d9001b">
            {{ hint }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getToken } from "@/utils/cookie";

export default {
  props: {
    fileName: {
      type: String,
      default: "药品基础信息维护导入模板.xlsx",
    },
    importUrl: {
      type: String,
      default: "MedicationInfo/ImportMedInfo",
    },
  },
  data() {
    return {
      fileList: [],
      uploadHeaders: {
        Authorization: `Bearer ${getToken()}`,
      },
      actionUrl: config.drugServerHost,
      errTableData: [],
      failDialogVisible: false,
      dialogVisible: false,
      errTableDataNum: 0,
      hint: "",
      onSuccessData: null,
    };
  },
  computed: {
    ...mapGetters(["token"]),
  },
  methods: {
    handleRemove(file, uploadFiles) {
      console.log(file, uploadFiles);
    },
    handlePreview(uploadFile) {
      console.log(uploadFile);
    },
    handleExceed(files, uploadFiles) {
      // Message.warning(
      //     `The limit is 3, you selected ${files.length} files this time, add up to ${files.length + uploadFiles.length
      //     } totally`,
      // );
    },
    beforeRemove(uploadFile, uploadFiles) {
      // return MessageBox.confirm(`Cancel the transfer of ${uploadFile.name} ?`).then(
      //     () => true,
      //     () => false,
      // );
    },
    downloadBlob(blob, filename) {
      try {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("下载文件时发生错误:", error);
      }
    },
    onSuccess(response, file) {
      if (!response.successful) return ElMessage.error(response.errorMessage);
      console.log(response.returnData.errorCount);

      if (response.returnData.errorCount > 0) {
        this.onSuccessData = response;
        this.errTableDataNum = response.returnData.errorCount;
        if (Number(this.errTableDataNum) > 10) {
          this.hint = "数据太多，请下载查看~";
        }
        this.errTableData = response.returnData.infoViews.map((item, index) => {
          if (!item.success && index <= 10) {
            return {
              result: "失败",
              resultMsg: item.msg,
              medicationName: item.medicationName,
            };
          }
        });
        this.failDialogVisible = true;
        return;
      } else {
        this.$my_message("导入成功！", "success");
      }
    },
    handleDownload() {
      const fileData = this.onSuccessData.returnData.fileData;
      const fileContents = fileData.fileContents;
      const contentType = fileData.contentType;
      const fileDownloadName = fileData.fileDownloadName;

      if (
        typeof fileContents === "string" &&
        fileContents.startsWith("data:")
      ) {
        const base64Data = fileContents.split(",")[1];
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: contentType });
        this.downloadBlob(blob, fileDownloadName);
      } else if (typeof fileContents === "string") {
        const byteCharacters = atob(fileContents);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: contentType });
        this.downloadBlob(blob, fileDownloadName);
      } else if (fileContents instanceof ArrayBuffer) {
        const blob = new Blob([fileContents], { type: contentType });
        this.downloadBlob(blob, fileDownloadName);
      } else {
        console.error("Unexpected data format:", fileContents);
      }
    },
    async handleCommand(type) {
      switch (type) {
        case "download":
          // 使用 BASE_URL 动态生成路径
          const baseUrl = process.env.BASE_URL || "";
          const filePath = `${baseUrl}template/${this.fileName}`;

          const link = document.createElement("a");
          link.href = filePath;
          link.download = this.fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.$my_message("文件下载成功！", "success");
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
:deep(.el-upload-dragger) {
  background: #F5F7FE;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.error-table {
  padding-bottom: 20px;
}

.uploading-btn {
  margin-right: 0.7143rem;
}

:deep(.el-button--default) {
  margin-right: 0 !important;
}

:deep(.el-button:focus-visible) {
  outline: transparent;
}

.upload-demo {
  width: 100%;
}

:deep(.el-upload__tip) {
  font-size: 1rem;
}
</style>
